import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import React from 'react';
import appRoutes from './routes';
import { MsalProvider } from '@azure/msal-react';
import apolloClient from './apolloClient';
import ViewProceedingPage from './pages/ViewProceedingPage';
import { Worker } from '@react-pdf-viewer/core';

const queryClient = new QueryClient();

const App = ({ msalInstance }: any) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={apolloClient}>
        <MsalProvider instance={msalInstance}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Router>
              <Routes>
                {appRoutes.map((route) => (
                  <Route key={route.path} path={route.path} element={<route.component />} />
                ))}
                <Route path="/hearing/proceeding/:proceedingId" element={<ViewProceedingPage />} />{' '}
              </Routes>
            </Router>
          </Worker>
        </MsalProvider>
      </ApolloProvider>
    </QueryClientProvider>
  );
};

export default App;
